var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7861 10.5059C18.191 10.6279 20.1035 12.6165 20.1035 15.0518L20.0977 15.2861C20.0476 16.2721 19.6832 17.1749 19.1035 17.8975L22.3535 21.1475L21.6465 21.8545L18.3965 18.6045C17.6172 19.2293 16.6283 19.6035 15.5518 19.6035L15.3174 19.5977C12.9901 19.4796 11.1239 17.6134 11.0059 15.2861L11 15.0518C11 12.5379 13.0379 10.5 15.5518 10.5L15.7861 10.5059ZM15.5518 11.5C13.5902 11.5 12 13.0902 12 15.0518C12 17.0133 13.5902 18.6035 15.5518 18.6035C17.5133 18.6035 19.1035 17.0133 19.1035 15.0518C19.1035 13.0902 17.5133 11.5 15.5518 11.5Z",
    fill: "currentColor",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.cc3e9ce19d1f9e3d51476d4f87b6b454.svg";
export { ForwardRef as ReactComponent };